<div class="appointment-location-container" [id]="location.idPerfilPublicoDetalle">
    <div class="location-header">        
        <span class="location-title">
            {{appointmentLocation.name}}
        </span>
        <div class="address-container">
            <span *ngIf="appointmentLocation.address">
                <span>{{appointmentLocation.address}}</span>                
                <span class="dot-separator">•</span>
            </span>
            <button mat-button *ngIf="!appointmentLocation.mapDisabled" (click)="onClickShowMap()">
                {{ 'publicProfiles.appointmentLocation.mapLink' | translate:locale.language }}
            </button>
        </div>
        <div class="contacts-container">
            <span>{{appointmentLocation.contacts}}</span>
        </div>
        <div class="additional-info-container" *ngIf="appointmentLocation.additionalInformation">
            {{appointmentLocation.additionalInformation}}
        </div>
    </div>
    <div class="location-content" *ngIf="!appointmentLocation.showMap && !loading">
        <div class="schedule-container" *ngIf="appointmentLocation.online && appointmentLocation.schedules" 
            [ngClass]="{'loading': appointmentLocation.loading, 'show-collapse': appointmentLocation.showCollapsable && !appointmentLocation.collapseOpened, 'virtual': appointmentLocation.virtual  }">
            <div class="schedule-header">
                <button mat-icon-button class="btn-prev" [disabled]="!appointmentLocation.btnPreviousEnabled" (click)="onClickBtnPrevious()">
                    <mat-icon fontSet="phr-iconset" class="phr-iconset-arrow-down"></mat-icon>
                </button>
                <div class="schedule-header-columns" [ngStyle]="{'grid-template-columns': 'repeat(' + appointmentLocation.schedules.length + ', 1fr)'}">
                    <div class="schedule-header-column" *ngFor="let scheduleItem of appointmentLocation.schedules">
                        <span>{{ 'publicProfiles.appointmentLocation.' + scheduleItem.dayName | translate:locale.language }}</span>
                        <span>{{scheduleItem.day + ' '}}{{ 'publicProfiles.appointmentLocation.' + scheduleItem.monthName | translate:locale.language }}</span>
                    </div>
                </div>
                <button mat-icon-button class="btn-next" (click)="onClickBtnNext()">
                    <mat-icon fontSet="phr-iconset" class="phr-iconset-arrow-down"></mat-icon>
                </button>
            </div>
            <div class="schedule-content" [ngStyle]="{'grid-template-columns': getScheduleColumnStyle() }">
                <ng-container *ngIf="!appointmentLocation.nextAvailableAppointmentDate">
                    <div class="schedule-content-column" *ngFor="let scheduleItem of appointmentLocation.schedules">
                        <div class="schedule-date-item" *ngFor="let scheduleDateItem of scheduleItem.dates"
                            [ngClass]="{'disabled': !scheduleDateItem.enabled }"
                            (click)="gotoCheckout(scheduleDateItem)">
                            <span *ngIf="scheduleDateItem.date">{{ scheduleDateItem.date | date:'shortTime': 'UTC' : language}}</span>
                        </div>
                    </div>
                </ng-container>

                <div class="next-appointment-container" *ngIf="appointmentLocation.nextAvailableAppointmentDate">                    
                    <div>
                        <mat-icon fontSet="phr-iconset" class="phr-iconset-date"></mat-icon>
                        <span>{{'publicProfiles.appointmentLocation.nextAvailableAppointment' | translate:locale.language}}</span>
                    </div>
                    <button mat-flat-button color="primary" (click)="moveScheduleToAvailableAppointment()">
                        {{appointmentLocation.nextAvailableAppointmentDate | date:'EEEE d MMMM y, h:mm a': 'UTC': language }}
                    </button>
                </div>
            </div>
            <div class="schedule-footer" *ngIf="appointmentLocation.showCollapsable"
                [ngStyle]="{'grid-template-columns': 'repeat(' + appointmentLocation.schedules.length + ', 1fr)'}">
                <div class="schedule-footer-column" *ngFor="let scheduleItem of appointmentLocation.schedules">
                    <div class="schedule-footer-item">
                        <button mat-button *ngIf="showViewMoreText(scheduleItem)" (click)="onClickBtnCollapse()">
                            {{'publicProfiles.appointmentLocation.viewMoreText' | translate:locale.language}}
                        </button>
                        <button mat-button *ngIf="showViewLessText(scheduleItem)" (click)="onClickBtnCollapse()">
                            {{'publicProfiles.appointmentLocation.viewLessText' | translate:locale.language}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="online-appointment-schedule-container not-online-appointment" *ngIf="!appointmentLocation.online && appointmentLocation.contacts">            
            <div class="contact-container">
                <span>{{'publicProfiles.appointmentLocation.onlineAppointmentDisabled' | translate:locale.language}}: </span>
                <span class="contact-info">{{appointmentLocation.contacts}}</span>
            </div>
        </div>
        <div class="online-appointment-schedule-container not-online-appointment" *ngIf="!appointmentLocation.online && !appointmentLocation.contacts">
            <div class="contact-container">
                <span>{{'publicProfiles.appointmentLocation.onlineAppointmentDisabled2' | translate:locale.language}}</span>
            </div>
        </div>
    </div>
    <div class="location-map" *ngIf="appointmentLocation.showMap">
        <button mat-icon-button (click)="appointmentLocation.showMap = false"><mat-icon fontSet="phr-iconset" class="phr-iconset-close"></mat-icon></button>

        <google-map height="300px" width="100%" [center]="{lat: appointmentLocation.lat, lng: appointmentLocation.lng}" [zoom]="appointmentLocation.zoom">
            <map-marker [position]="{lat: appointmentLocation.lat, lng: appointmentLocation.lng}"></map-marker>
        </google-map>
    </div>

    <div class="skeleton-appointment-location" *ngIf="loading">

        <div class="skeleton-header" [ngStyle]="{'grid-template-columns': getSkeletonColumnStyle() }">
            <div *ngFor="let number of [].constructor(numberOfDays + 1)">
                <ngx-skeleton-loader [theme]="{ 'display': 'block', 'width': '50px', 'height': '17px', 'margin': 'auto', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px'}"></ngx-skeleton-loader>
            </div>
            <div *ngFor="let number of [].constructor(numberOfDays + 1)">
                <ngx-skeleton-loader [theme]="{ 'display': 'block', 'width': '40px', 'height': '10px', 'margin': 'auto', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px'}"></ngx-skeleton-loader>
            </div>
        </div>
        <div class="skeleton-content" [ngStyle]="{'grid-template-columns': getSkeletonColumnStyle() }">
            <div *ngFor="let number of [].constructor(numberOfDays + 1)">
                <ngx-skeleton-loader [theme]="{ 'display': 'block', 'width': '99%', 'height': '46px', 'margin': 'auto', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px'}"></ngx-skeleton-loader>
            </div>
            <div *ngFor="let number of [].constructor(numberOfDays + 1)">
                <ngx-skeleton-loader [theme]="{ 'display': 'block', 'width': '99%', 'height': '46px', 'margin': 'auto', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px'}"></ngx-skeleton-loader>
            </div>
            <div *ngFor="let number of [].constructor(numberOfDays + 1)">
                <ngx-skeleton-loader [theme]="{ 'display': 'block', 'width': '99%', 'height': '46px', 'margin': 'auto', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px'}"></ngx-skeleton-loader>
            </div>
        </div>        
    </div>
</div>